import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsAgencyModal from './agencyModal';
import WtsAgencyTechDetailsModal from './agencyDetailsModal';

const {
  getWtsAgencies,
  updateWtsAgencyStatus,
  getWtsDealer,
} = Actions;

function WtsAgency({activeTab}) {
  const wtsSkills = useSelector((state) => state.wtsAgencies.agencies);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 1) {
      dispatch(getWtsAgencies(areaSelected.id));
      dispatch(getWtsDealer());
    }
  }, [areaSelected, activeTab]);

  const updateStatus = (e, checkedValue, item) => {
    e.preventDefault();
    dispatch(updateWtsAgencyStatus(areaSelected.id,
      {'data': {...item, 'status': checkedValue ? 'ACTIVO' : 'INACTIVO'}}));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'ACTIVO', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'INACTIVO', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value && areaSelected) {
            dispatch(getWtsAgencies(areaSelected.id));
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">CÓDIGO</span>,
      'accessor': 'id',
    },
    {
      'Header': () => <span className="header-title">AGENCIA</span>,
      'accessor': 'description',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO CONCESIONARIO</span>,
      'accessor': 'dealerCode',
      'Cell': (item) => (
        <div>
          <div>{item.value || 'Sin asignar'}</div>
          <small style={{'color': 'gray'}}> {item.row.original.gestor_email} </small>
        </div>
      ),
    },
    {
      'Header': () => <span className="header-title">CONCESIONARIO</span>,
      'accessor': 'dealer',
    },
    {
      'Header': () => <span className="header-title">GESTOR</span>,
      'accessor': 'gestorName',
      'Cell': (item) => (
        <div>
          <div>{item.value || 'Sin asignar'}</div>
          <small style={{'color': 'gray'}}> {item.row.original.gestor_email} </small>
        </div>
      ),
    },
    {
      'Header': () => <span className="header-title">EVALUADOR</span>,
      'accessor': 'evaluatorName',
      'Cell': (item) => (
        <div>
          <div>{item.value || 'Sin asignar'}</div>
          <small style={{'color': 'gray'}}>{item.row.original.evaluator_email}</small>
        </div>
      ),
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return (
          <Checkbox
            toggle
            checked={item.value === 'ACTIVO'}
            className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'skills_actions',
      'width': 1,
      'Cell': (item) => {
        return (
          <div className='flex center end'>
            <WtsAgencyModal mode='edit' agencyToEdit={item.row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsAgencyModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsAgencyTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column floated='left'>
          <CommercialTable
            columns={columns}
            data={wtsSkills}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsAgency;
